module.exports = __webpack_public_path__ + "img/about-m-slide-2.61d149a8.jpg";